const LS_LANDING = 'first_landing_url';
const LS_REFERRER = 'first_referrer_url';

// Keep the query string: Landing_Page__c should show the UTMs the visitor
// actually landed with (the consumer truncates to its own field limit).
const safePath = () => {
  const path = location.pathname && location.pathname.trim().length ? location.pathname : '/';

  return `${path}${location.search || ''}`;
};

export const rememberLanding = (): void => {
  try {
    if (!sessionStorage.getItem(LS_LANDING)) {
      sessionStorage.setItem(LS_LANDING, safePath());
    }
    if (!sessionStorage.getItem(LS_REFERRER)) {
      sessionStorage.setItem(LS_REFERRER, document.referrer || '');
    }
  } catch {
    /* empty */
  }
};

export const readLanding = (): { landing: string; referrer: string } => {
  try {
    return {
      landing: sessionStorage.getItem(LS_LANDING) || safePath(),
      referrer: sessionStorage.getItem(LS_REFERRER) || document.referrer || '',
    };
  } catch {
    return { landing: safePath(), referrer: document.referrer || '' };
  }
};
